'use client'
import '@dynamic-labs/sdk-api-core';
import { logger } from '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/wallet-book';
import '../../constants/colors.js';
import '../../constants/values.js';
import '../../../shared/utils/classes/storage/localStorage.js';
import '../../../shared/utils/classes/storage/sessionStorage.js';
import '@dynamic-labs/utils';
import '../../../shared/consts/index.js';

const serializeWalletConnectors = (walletConnectors) => {
    try {
        if (!walletConnectors)
            return undefined;
        return walletConnectors.map((connector) => connector.name);
    }
    catch (error) {
        logger.error('error serializing walletConnectors', error);
        return undefined;
    }
};

export { serializeWalletConnectors };
